/* eslint-disable no-underscore-dangle */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import useStoreData from '../../hooks/useStoreData';

import './StoreStatus.styl';

/**
 * Composant affichant les informations et le statut du magasin
 */
const StoreStatus = ({
    showBassin = true,
    showRegion = false,
    compact = false,
}) => {
    const { storeData, isLoading, error, isOnline } = useStoreData();

    // Mettre en cache les éléments d'interface pour éviter les re-rendus inutiles
    const content = useMemo(() => {
        if (isLoading) {
            return (
                <div className='store-status-loading'>
                    Chargement des données du magasin...
                </div>
            );
        }

        if (error) {
            return (
                <div className='store-status-error'>
                    {error}
                    {isOnline === false && (
                        <div className='store-offline-notice'>
                            Mode hors ligne
                        </div>
                    )}
                </div>
            );
        }

        if (!storeData) {
            return (
                <div className='store-status-error'>
                    Données du magasin non disponibles
                </div>
            );
        }

        return (
            <div className='store-info'>
                <div id='app-version'>
                    <strong>Version:</strong> {process.env.__VERSION__}
                </div>
                {storeData.label && (
                    <div className='store-label'>
                        <strong>Magasin:</strong> {storeData.label}
                    </div>
                )}

                {showBassin && storeData.bassin && (
                    <div className='store-bassin'>
                        <strong>Bassin:</strong> {storeData.bassin}
                    </div>
                )}

                {showRegion && storeData.region && (
                    <div className='store-region'>
                        <strong>Région:</strong> {storeData.region}
                    </div>
                )}

                {isOnline === false && (
                    <div className='store-offline-notice'>Mode hors ligne</div>
                )}
            </div>
        );
    }, [storeData, isLoading, error, isOnline, showBassin, showRegion]);

    // Classe CSS calculée une seule fois
    const className = useMemo(() => {
        let cls = 'store-status';
        if (compact) cls += ' compact';
        if (error) cls += ' error';
        return cls;
    }, [compact, error]);

    return <div className={className}>{content}</div>;
};

StoreStatus.propTypes = {
    showBassin: PropTypes.bool,
    showRegion: PropTypes.bool,
    compact: PropTypes.bool,
};

StoreStatus.defaultProps = {
    showBassin: true,
    showRegion: false,
    compact: false,
};

export default StoreStatus;
